<template>
	<form action="" class="form" @submit.prevent="submit">
		<div class="form-control">
			<label class="form-label">Электронная почта / Логин</label>
			<input v-model="login" class="form-input" type="text" name="email" />
			<label v-if="isValid && !login" class="error">Это поле обязательно</label>
		</div>
		<div class="form-control">
			<label class="form-label">Пароль</label>
			<input v-model="password" class="form-input" type="password" name="password" />
			<label v-if="isValid && password.length < 6" class="error">
				Минимальная длина пароля 6 символов
			</label>
			<nuxt-link to="/profile/reset" class="form-resetLink">Забыли пароль?</nuxt-link>
		</div>
		<div class="form-control text-center">
			<div class="form-buttons form-buttons_auth">
				<div class="form-buttonsItem">
					<div class="button" @click="submit"><span>Войти</span></div>
				</div>
				<div class="form-buttonsItem">
					<nuxt-link tag="div" to="/profile/register" class="button2">
						<span>Регистрация</span>
					</nuxt-link>
				</div>
			</div>
			<div class="form-buttons">
				<div class="form-buttonsItem">
					<socials></socials>
				</div>
			</div>
		</div>
	</form>
</template>
<script>
import socials from '@/components/socials.vue';

export default {
	components: { socials },
	data() {
		return {
			login: '',
			password: '',
			isValid: false,
		};
	},
	computed: {
		valid() {
			return this.login && this.password && this.password.length >= 6;
		},
	},
	methods: {
		submit() {
			this.isValid = true; //отображаем ошибки
			if (this.valid)
				this.$emit('submit', {
					login: this.login,
					password: this.password,
				});
		},
	},
};
</script>
